import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Injectable()
export class PublicService {

  constructor(private http: HttpClient) {
  }

  getOrder(id: any)  {
    return this.http.get(`${environment.magentoServiceApiUrl}/public/order?token=${id}`);
  }

  approveOrder(data: any)  {
    return this.http.post(`${environment.magentoServiceApiUrl}/public/order/approve`, data);
  }

  updateInnerCaseLabel(data: any)  {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(`${environment.rfidLambdaEndpoint}/innercase-label`, data, { headers });
  }

  // invoke lambda through api gateway
  getInnerCaseLabelImage(orderId: string | number, jobId: string | number) {
    const params = new HttpParams()
      .set('bucket', environment.rfidInnerCaseLabelBucket)
      .set('key', `innerCaseLabel-single-${orderId}-${jobId}.png`);
    
    return this.http.get(`${environment.rfidLambdaEndpoint}/convert-image`, {
      params,
      responseType: 'text'
    });
  }

  getSignedUrl(data: any)  {
    return this.http.post(`${environment.magentoServiceApiUrl}/get-signed-url`, data);
  }

  uploadFileToS3(file: File, signedUrl: string) {
    const headers = new HttpHeaders({ 'Content-Type': file.type });

    return this.http.put(signedUrl, file,  {
      headers,
      reportProgress: true,
      observe: 'events', // Keep progress tracking
      responseType: 'text' // Prevent Angular from parsing the response as JSON
    });
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/services/public.service.ts